import { createDialog } from '@/infrastructure/decorators/dialog';
export function createRequestSpaceCreateDataService() {
    return createDialog(() => import('@/presentation/components/workspaces/create-space-dialog/CreateWorkspaceDialog.vue'));
}
